import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faTwitter } from "@fortawesome/free-brands-svg-icons" // 追加
library.add(faTwitter)

const TwitterIcon = () => {
  return (
    <a
      href="https://twitter.com/poppotennis_mda"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faTwitter} />
    </a>
  )
}

export default TwitterIcon
